<template>
    <div class="footer" id="footer">
        <div class="fot_part" v-if="!isSoucaiGroupDomain">
            <div class="contact aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <div class="f_phone">
                    <img class="bottom_logo" src="https://cdn.kuailework.com/images/officialWebsite/index/bottom_logo.png" alt="" />
                    <img class="icon_erweima" src="https://cdn.kuailework.com/images/officialWebsite/index/img_erweima.png " alt=" " />
                    <p class="phone_code mob">400-607-6006</p>
                </div>
            </div>
            <div class="public_bottom aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                <h6 class="">产品与服务</h6>
                <a href="/talentAllocation" style="color: rgb(51, 51, 51)">人才配置服务</a>
                <a href="/talent" style="color: rgb(51, 51, 51)">人力外包服务</a>
                <a href="/development" style="color: rgb(51, 51, 51)">人才培训与发展</a>
                <a href="/consult" style="color: rgb(51, 51, 51)">企业管理咨询</a>
            </div>
            <div class="public_bottom aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                <h6 class="">行业解决方案</h6>
                <a href="/industry" style="color: rgb(51, 51, 51)">即配物流</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">互联网</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">高端制造</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">通信运营</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">能源</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">金融保险</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">食品快消</a>
                <a href="/industry" style="color: rgb(51, 51, 51)">政府央国企</a>
            </div>
            <div class="public_bottom aos-init aos-animate" data-aos="fade-up" data-aos-delay="600">
                <h6 class=""><a href="/integration?typename=yth" style="color: rgb(51, 51, 51)">数字化平台</a></h6>
                <h6 class=""><a href="/news?typename=集团动态" style="color: rgb(51, 51, 51)">资讯中心</a></h6>
                <h6 class=""><a href="/about" style="color: rgb(51, 51, 51)">关于我们</a></h6>
                <p>
                    友情链接：
                    <a href="https://zhaogongya.com/" target="_blank" style="color: rgb(51, 51, 51)">找工呀</a>
                    <a href="https://www.budao.com/" target="_blank" style="color: rgb(51, 51, 51)">布道教育</a>
                    <!--<a href="http://www.soucai.com/" target="_blank" style="color: rgb(51, 51, 51);">搜才网</a>-->
                </p>
            </div>
        </div>
        <div class="copy_right" v-if="!isSoucaiGroupDomain">
            <p style="text-align: center; padding-top: 10px">2001-2024北京快乐沃克科技有限公司</p>
            <p style="text-align: center; padding-top: 10px">北京市朝阳区双井街道富力双子座A座2702</p>
            <p style="text-align: center; padding-top: 10px">
                <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(51, 51, 51)">京ICP备2024094492号-2</a>
                |
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010802001299" target="_blank" style="color: rgb(51, 51, 51)">京公网安备11010502057241号</a>
            </p>
        </div>
        <div v-if="isSoucaiGroupDomain" class="copy_right_soucai">
            <div class="contact aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <div class="f_phone">
                    <img class="bottom_logo" src="https://cdn.kuailework.com/images/officialWebsite/index/bottom_logo.png" alt="" />
                    <img class="icon_erweima" src="https://cdn.kuailework.com/images/officialWebsite/index/img_erweima.png " alt=" " />
                    <p class="phone_code mob">400-607-6006</p>
                </div>
            </div>
            <div>
                <p style="text-align: center; padding-top: 10px">2001-2024快乐沃克人力资源股份有限公司</p>
                <p style="text-align: center; padding-top: 10px">河北省石家庄市裕华区槐安东路121号裕华万达广场5A写字楼401</p>
                <p style="text-align: center; padding-top: 10px">
                    <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备05001356号</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'myFooter',
    computed: {
        /**
         * 判断当前域名是否为 kuailework
         * @returns {boolean} 是否为 kuailework 域名
         */
        isKuaileWorkDomain() {
            return window.location.hostname.includes('kuailework');
        },
        /**
         * 判断当前域名是否为 soucaigroup
         * @returns {boolean} 是否为 soucaigroup 域名
         */
        isSoucaiGroupDomain() {
            return window.location.hostname.includes('soucaigroup');
        },
    },
};
</script>

<style scoped>
.footer {
    width: 100%;
    height: auto;
    text-align: left;
    background: #0e1421;
    overflow: hidden;
    /* margin-top: 48px; */
    padding-bottom: 70px;
}
.footer img {
    margin-right: 0px;
}
.footer a {
    text-decoration: none;
}
.fot_part {
    width: 1200px;
    margin: 0 auto;
    margin-top: 50px;
}
.f_r_same {
    margin-left: 80px;
}
/* .f_r_same:last-child {
      margin-left: 60px;
    } */
.f_t {
    font-size: 14px;
    font-weight: bolder;
    color: #999;
}

.er_code {
    display: flex;
    align-items: center;
}

.f_code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.code_wrap {
    width: 100px;
    height: 100px;
}
.code_wrap img {
    width: 100px;
    height: 100px;
}
.f_phone {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    /* margin-top: 40px; */
}
.phone_code {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    color: #fff;
}

.f_phone img.bottom_logo {
    width: 80px;
    height: 30px;
    margin-bottom: 10px;
}
.f_phone img.icon_erweima {
    width: 110px;
    height: 110px;
    cursor: pointer;
    margin-bottom: 10px;
    /* margin-top: 16px; */
}
.f_phone img.icon_erweima:hover {
    transform: scale(1.1);
    transition: all 0.3s;
}

.mob img {
    width: 14px;
    height: 24px;
    margin-right: 13px;
    margin-left: 4px;
    margin-top: -2px;
}

.f_sec_code {
    margin-left: 28px;
}

.f_code p {
    font-size: 12px;
    margin-top: 8px;
    color: #fff;
}

.se_p {
    margin-top: 20px;
    margin-bottom: 28px;
}

.er_code {
    margin-top: 24px;
}

.f_pr {
    /* margin-left: 160px; */
}

.f_sub_menu {
    color: #595757;
    font-size: 14px;
    line-height: 44px;
    margin-top: 14px;
}

.f_sub_menu p a {
    color: #fff !important;
    margin-right: 20px;
    font-size: 14px;
    display: inline-block;
    min-width: 66px;
}
.f_sub_menu p a:hover {
    color: #228d4a !important;
}

.link p a {
    color: #0cab04 !important;
    margin-right: 20px;
    font-size: 14px;
    display: inline-block;
    /* min-width: 56px; */
}
.link p a:hover {
    color: #228d4a !important;
}

.copy_right_soucai {
    margin: 0 auto;
    width: 1200px;
    color: #999;
    font-size: 14px;
    border-top: 1px solid #1a2132;
    box-sizing: border-box;
    margin-top: 24px;
    color: #999 !important;
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.copy_right {
    width: 1200px;
    margin: 0 auto;
    color: #999;
    font-size: 14px;
    border-top: 1px solid #1a2132;
    box-sizing: border-box;
    margin-top: 24px;
    color: #999 !important;
    padding-top: 30px;
    text-align: center;
}
.copy_right span {
    float: left;
    margin-right: 58px;
}
.link {
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding-top: 4px;
    margin-top: 20px;
    padding-top: 0px;
    text-align: center;
}
.link p {
    font-size: 14px;
    color: #fff !important;
    margin-left: 64px;
    margin-bottom: 16px;
}

/* æœåŠ¡å†…å®¹å…¬å…±æ ·å¼ */

.part_item {
    border-radius: 10px;
    overflow: hidden;
    float: left;
}

.middle_part {
    margin: 0 60px;
}

.part_tit_icon {
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: url(https://cdn.kuailework.com/images/klwk/public/icon_icon.png) no-repeat top center;
    background-size: cover;
    float: left;
}

.part_tit_cont {
    float: left;
    font-size: 20px;
    color: #ffffff;
    margin-left: 3px;
}

.pr_ans_info {
    font-size: 16px;
    margin-top: 16px;
}

.pr_ans_info p {
    text-align: center;
    font-size: 16px;
    color: #221815;
    line-height: 40px;
}

/* æœåŠ¡ä»·å€¼å…¬å…±æ ·å¼ */

.pr_ex_tit {
    text-align: center;
    font-size: 32px;
    height: 32px;
    line-height: 32px;
    margin: 50px 0 42px 0;
    letter-spacing: 3px;
}
.pr_ex_part {
    width: 1202px;
    margin: 0 auto;
    display: flex;
    align-items: baseline;
}
.pr_ex_part_item {
    width: 374px;
    height: 346px;
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #fff;
    margin-right: 40px;
    text-align: justify;
    border-radius: 10px;
    box-shadow: 0 0 8px #9c9c9c;
}
.pr_ex_part_item:last-child {
    margin-right: 0;
}

.pr_ex_part_item .pr_ex_l {
    width: 374px;
    height: 186px;
}

.pr_ex_part_item .pr_ex_l img {
    width: 374px;
    height: 186px;
}

.pr_ex_part_item .pr_ex_r {
    position: relative;
    width: 374px;
    box-sizing: border-box;
    padding: 0 20px;
}

.pr_ex_part_item .pr_ex_r h6 {
    font-size: 18px;
    text-align: left;
    font-weight: normal;
    margin-top: 22px;
}

.pr_ex_part_item .pr_ex_r p {
    color: #898989;
    font-size: 14px;
    text-align: justify;
    line-height: 30px;
    margin-top: 9px;
}

/* home */

.code_wrap img {
    transform: translate(0, 0);
    transition: all 0.3s ease-out 0s;
    border-radius: 4px;
}

.code_wrap img:hover {
    transform: scale(1.2);
}

.pagenation {
    width: 100%;
    padding: 30px 0 60px 0;
    background-color: #ffffff;
    text-align: center;
}

.pagenation ul li {
    display: inline-block;
    margin: 0 5px;
}

.pagenation ul li.active {
    font-weight: 700;
}

.pagenation ul li a {
    display: block;
    float: left;
    min-width: 50px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    border: #ccc solid 1px;
    border-radius: 8px;
    color: #222 !important;
}
.pagenation ul li a:hover {
    color: #00b536 !important ;
}
.pagenation ul li.active a {
    color: #fff;
    background: #00b536;
    color: #fff !important;
    cursor: default;
    border: none;
}
.copy_right a {
    color: #999 !important;
    /* min-width: 56px; */
}
.copy_right a:hover {
    color: #228d4a !important;
}
.public_bottom {
    display: flex;
    flex-direction: row;
    width: auto;
    margin-bottom: 44px;
    padding-top: 6px;
}
.public_bottom h6 {
    display: inline-block;
    width: 92px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    margin-right: 64px;
}
.public_bottom a {
    display: inline-block;
    margin-right: 30px;
    font-size: 14px;
    color: #999999 !important;
}
.public_bottom h6 a {
    display: inline-block;
    width: 92px;
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;
}
.public_bottom a:hover {
    color: #0cab04 !important;
}
.public_bottom p {
    font-weight: bold;
    font-size: 14px;
    color: #fff;
}
.public_bottom p a {
    color: #0cab04 !important;
    text-decoration: underline;
    font-size: 14px;
}
.contact {
    float: left;
    width: 110px;
    align-items: center;
    margin-left: 62px;
    margin-right: 100px;
}
.contact_icon label {
    /* position: absolute; */
    top: 22px;
    width: 28px;
    height: 28px;
}
</style>
